module.exports = __webpack_public_path__ + "static/media/15.07fdf16a.jpg";